<script>
  import { isArray } from 'lodash'
  import LoteDebitoService from '../../../../../domain/leiloes/services/lote-debito'
  import PopupViewer from '../../../../_default/components/popup-viewer/PopupViewer'
  import {VueMaskDirective as mask} from 'v-mask'
  import {REAL_BRL} from '../../../../../utils/helpers/money'
  import {VMoney} from 'v-money'

  export default {
    components: {
      PopupViewer,
      NovoTipoLoteDebito: () => import('./NovoTipoLoteDebito')
    },
    directives: {mask, money: VMoney},
    nome: 'novo-lote-debito',
    props: {
      debitoId: {
        type: Number,
        required: false,
        default: null
      }
    },
    data () {
      return {
        money: REAL_BRL,
        isLoading: false,
        isLoaded: false,
        cadastroError: null,
        atualizadoSucesso: null,
        data: {
          descricao: null,
          valor: null,
          tipo: null,
          ordem: null
        },
        tiposDebito: [],
        showTipoDebitoForm: false
      }
    },
    computed: {
      valorDebitoFloat () {
        if (!this.data.valor) {
          return
        }
        const convertMoneyToFloat = str => +str.replace(/^\D*/, '').replace(/\./, '').replace(/,/, '.')
        return convertMoneyToFloat(this.data.valor)
      }
    },
    created () {
      this.carregarTiposDebito()
    },
    mounted () {
      this.start()
    },
    activated () {
    },
    destroyed () {
    },
    watch: {},
    methods: {
      start () {
        if (this.debitoId) {
          this.$parent.loading(true)
          LoteDebitoService.findDebitoLote(this.debitoId)
            .then((response) => {
              this.isLoaded = true
              this.data = response.data
              this.data.tipo = this.data.tipo.id
            })
            .catch((response) => {
              console.log(response)
            })
            .finally(() => {
              this.$parent.loading(false)
            })
        } else {
          this.isLoaded = true
          // this.$loaderOverlay.open().message('Aguarde')
        }
      },
      submit () {
        this.cadastroError = null
        this.atualizadoSucesso = false
        this.$bar.start()
        this.$parent.loading(true)
        const data = JSON.parse(JSON.stringify(this.data))
        data.valor = this.valorDebitoFloat
        LoteDebitoService.cadastroDebitoLote(data, this.$route.params.id, this.debitoId)
          .then((response) => {
            let callbackEnd = () => {
              this.$bar.finish()
              if (this.$route.params.id) {
              // Continua na mesma tela de edição
              // this.$nextTick(() => {
                this.start()
                this.atualizadoSucesso = true
                this.$el.querySelector('#sucessMsg').focus()
              // })
              } else {
              // Redirecionr para tela de visualização
              // this.$router.push({name: 'documento.editar', params: {id: response.data.id}})
                this.atualizadoSucesso = true
              }
              this.$emit('finishSubmit')
            }
            callbackEnd()
          }).catch((response) => {
            this.$bar.finish()
            this.cadastroError = response.data.errors
            this.$nextTick(() => {
              this.$refs.error.focus()
            })
            console.log(response)
          })
          .finally(() => {
            this.$parent.loading(false)
          })
      },
      carregarTiposDebito () {
        LoteDebitoService.listAllTipoDebito()
          .then(response => {
            this.tiposDebito = response.data
          })
          .catch(error => {
            this.cadastroError = error.data.errors
          })
      },
      openTipoDebitoForm () {
        this.showTipoDebitoForm = true
      },
      closeTipoDebitoForm () {
        this.showTipoDebitoForm = false
      },
      finishSubmitCadastroTipoDebito () {
        this.closeTipoDebitoForm()
        this.carregarTiposDebito()
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Gerenciamento de Débitos</h1></div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar, corrija e tente novamente</div>
              <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso" class="alert alert-success">
              <div class="font-bold">{{$route.params.id && 'Atualizado' || 'Cadastrado'}} com sucesso!</div>
            </div>
            <form @submit.prevent="submit" class="bs-example form-horizontal">

              <div class="form-group">
                <label class="col-sm-4 control-label">Descrição</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.descricao" required />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">Valor</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.valor" required v-money="money"/>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">Tipo</label>
                <div class="col-sm-8">
                  <select class="form-control" v-model="data.tipo" required>
                    <option :value="null" disabled>Selecione</option>
                    <option :value="tipo.id" v-for="tipo in tiposDebito" :key="tipo.id">{{tipo.nome}}</option>
                  </select>
                  <u-button class="btn btn-xs pull-right m-t-sm m-b-xs m-r-xs btn-default" @click="openTipoDebitoForm">
                    <i class="fa fa-plus"></i> Cadastrar tipo de débito
                  </u-button>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">Ordem</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.ordem" required />
                </div>
              </div>

              <div class="clearfix"></div>

              <hr>
              <div class="row wrapper">
                <u-button class="btn m-b-xs w-xs btn-info m-r-xs" type="submit">
                  <span v-if="!data.id">Cadastrar</span>
                  <span v-if="data.id">Atualizar</span>
                </u-button>
                <u-button class="btn m-b-xs w-xs m-r-xs btn-default" @click="$emit('cancel')">Cancelar</u-button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <popup-viewer @close="closeTipoDebitoForm" v-if="showTipoDebitoForm" :title="`Cadastro de Tipo de Debito`">
        <NovoTipoLoteDebito @cancel="closeTipoDebitoForm" @finishSubmit="finishSubmitCadastroTipoDebito" />
      </popup-viewer>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// NovoLoteDebito.vue?1de8e451